import { IContactModel } from '@fi-shared/models/common';

export class ContactModel implements IContactModel {
    Id? = 0;
    ParentId? = undefined;
    ObjectId? = 0;
    ObjectType? = 1;
    ContactType? = 1;
    ContactValue? = '';
    ExtendedValue? = '';
    //FullContactValue? = '';
    CountryId? = undefined;
    IsDefault? = false;
    IsSignIn? = false;
    IsImported? = false;

    constructor(contact?: IContactModel) {
        if (contact) this.Initialize(contact);
    }

    Initialize(contact: IContactModel) {
        this.Id = contact.Id;
        this.ParentId = contact.ParentId;
        this.ObjectId = contact.ObjectId;
        this.ObjectType = contact.ObjectType;
        this.ContactType = contact.ContactType;
        this.ContactValue = contact.ContactValue;
        this.ExtendedValue = contact.ExtendedValue;
        //this.FullContactValue = contact.FullContactValue;
        this.IsDefault = contact.IsDefault;
        this.CountryId = contact.CountryId;
        this.IsSignIn = contact.IsSignIn;
        this.IsImported = contact.IsImported;
    }
}
